import { render } from "./ContentFrame.vue?vue&type=template&id=23b88330&scoped=true"
import script from "./ContentFrame.vue?vue&type=script&lang=js"
export * from "./ContentFrame.vue?vue&type=script&lang=js"

import "./ContentFrame.vue?vue&type=style&index=0&id=23b88330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b88330"]])

export default __exports__